import type { ComponentType } from 'react';
import { BalanceSheetReport, ProfitAndLossReport, TrialBalanceReport } from './FinancialReports';
import {
  CashMovementReport,
  PayablesAgingReport,
  PaymentsReport,
  ReceivablesAgingReport,
} from './PartyReports';
import { GrossProfitByPeriodReport, GrossProfitByProductReport } from './ProfitReports';
import {
  PurchasesByPeriodReport,
  PurchasesByProductReport,
  PurchasesBySupplierReport,
} from './PurchaseReports';
import {
  BestSellersReport,
  SalesByCustomerReport,
  SalesByPeriodReport,
  SalesByProductReport,
} from './SalesReports';
import { StockOnHandReport, LowStockReport, StockValuationReport } from './StockReports';

/** Report screens by slug (the slugs match `REPORTS` in the catalog). */
export const REPORT_SCREENS: Record<string, ComponentType> = {
  'sales-by-period': SalesByPeriodReport,
  'sales-by-customer': SalesByCustomerReport,
  'sales-by-product': SalesByProductReport,
  'best-sellers': BestSellersReport,
  'purchases-by-period': PurchasesByPeriodReport,
  'purchases-by-supplier': PurchasesBySupplierReport,
  'purchases-by-product': PurchasesByProductReport,
  'gross-profit-by-period': GrossProfitByPeriodReport,
  'gross-profit-by-product': GrossProfitByProductReport,
  'stock-on-hand': StockOnHandReport,
  'low-stock': LowStockReport,
  'stock-valuation': StockValuationReport,
  'receivables-aging': ReceivablesAgingReport,
  'payables-aging': PayablesAgingReport,
  payments: PaymentsReport,
  'cash-movement': CashMovementReport,
  'profit-and-loss': ProfitAndLossReport,
  'balance-sheet': BalanceSheetReport,
  'trial-balance': TrialBalanceReport,
};
